import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchWithAuth } from '@/data/api/client'
import type { OrganizationResponse } from '@/data/types/organization.types'

async function getOrganizations(): Promise<OrganizationResponse> {
    return fetchWithAuth('/api/v1/organizations')
}

interface CreateOrganizationRequest {
    name: string
    onboarding_data?: Record<string, any>
}

async function createOrganization(request: CreateOrganizationRequest): Promise<void> {
    const payload: Record<string, any> = { name: request.name }
    if (request.onboarding_data) {
        payload.onboarding_data = request.onboarding_data
    }
    return fetchWithAuth('/api/v1/organizations', {
        method: 'POST',
        body: JSON.stringify(payload),
    })
}

async function updateOrganization(name: string): Promise<void> {
    return fetchWithAuth('/api/v1/organizations', {
        method: 'PATCH',
        body: JSON.stringify({ name }),
    })
}

async function deleteOrganization(): Promise<void> {
    return fetchWithAuth('/api/v1/organizations', {
        method: 'DELETE',
    })
}

export function useOrganizations() {
    return useQuery({
        queryKey: ['organizations'],
        queryFn: getOrganizations,
    })
}

export function useCreateOrganization() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: createOrganization,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['organizations'] })
        },
    })
}

export function useUpdateOrganization() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: updateOrganization,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['organizations'] })
        },
    })
}

export function useDeleteOrganization() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: deleteOrganization,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['organizations'] })
        },
    })
}

